import * as TYPES from './types';
import { setRecentlyPropertyType } from '../_util';
import Vue from 'vue';
// import { searchCenter } from './isSearchCenter';
import { mobileOutFields, brokerMobileOutFields } from '../_conf';
function postUiConfig(uiConfig) {
    if (window.parent) {
        window.parent.postMessage(
            {
                action: 'update_ui_config',
                data: uiConfig
            },
            '*'
        );
    }
}
const common = {
    [TYPES.SET_OUT_SIDE_FIELDS](state, payload) {
        state.outsideFields = [...payload];
    },
    [TYPES.CLEAR_CONDITION](state) {
        state.condition = {};
    },
    [TYPES.RESET_MOBILE_CONDITION](state, isBroker) {
        let conditions = Object.assign({}, state.conditions);
        let outFileds = isBroker ? brokerMobileOutFields : mobileOutFields;
        Object.keys(state.conditions).filter(key => {
            if (outFileds.includes(key)) {
                return true;
            }
            delete conditions[key];
            return false;
        });
        state.conditions = conditions;
    },
    [TYPES.SET_SEARCH_CHARTS](state, payload) {
        state.searchCharts = [...payload];
    },
    [TYPES.SET_CUSTOMIZED_CITY](state, payload) {
        state.customizedCity = (payload || []).map(
            ({ name, keyName, key, type }) => {
                const label = name || keyName;
                const value = key;
                return {
                    label,
                    value,
                    type
                };
            }
        );
    },
    [TYPES.SET_LISTING_SOURCE](state, payload) {
        state.listingSource = payload;
    },
    [TYPES.SET_LISTING_IDS](state, payload) {
        state.listingIds = payload;
    },
    [TYPES.CURRENCY_PRICE_KEYS](state, arr) {
        state.currencyPriceKeys = arr;
    }
};
const mutations = {
    ...common,
    [TYPES.SET_SEARCH_CONFIG](state, payload) {
        const { fetcherData, moduleMap, conditionSort } = payload;
        state.fetcherData = { ...fetcherData };
        state.moduleMap = { ...moduleMap };
        state.conditionSort = [...conditionSort];
    },
    [TYPES.INITIAL_CONDITION](state, payload) {
        state.conditions = { ...payload };
    },
    [TYPES.UPDATE_CONDITION](state, payload) {
        if (payload.kee === 'Property-Type') {
            setRecentlyPropertyType(payload.value);
        }
        const conditions = { ...state.conditions, [payload.kee]: payload };
        if (!conditions[payload.kee].value) {
            delete conditions[payload.kee];
        }
        state.conditions = conditions;
    },
    [TYPES.SEARCH_RESET_MUTATION](state, more = false) {
        if (!more) {
            state.keywords = [];
            state.conditions = {};
            state.mapCondition = Object.assign({}, state.mapCondition, {
                mapPath: null
            });
        } else {
            let conditions = Object.assign({}, state.conditions);
            Object.keys(conditions).forEach(key => {
                if (conditions[key].inMore) {
                    delete conditions[key];
                }
            });
            state.conditions = conditions;
        }
    },
    [TYPES.SEARCH_QUERY_ON_URL](state, payload) {
        state.searchQueryOnUrl = { ...payload };
    },
    [TYPES.HAS_CONDITION_ON_URL](state, payload) {
        state.hasConditionOnUrl = payload;
    },
    [TYPES.LOCATION_QUERY_ON_URL](state, payload) {
        state.locationQueryOnUrl = payload;
    },
    [TYPES.URL_PRESET_PARAMS](state, payload) {
        state.urlPresetParams = payload;
    },
    [TYPES.MAP_CONDITION_ON_URL](state, payload) {
        state.mapConditionOnUrl = { ...state.mapConditionOnUrl, ...payload };
    }
};
const centerMutations = {
    ...common,
    [TYPES.CENTER_SET_SEARCH_CONFIG_MAP](state, payload) {
        const { fetcherData, moduleMap, conditionSort } = payload;
        state.fetcherData = { ...fetcherData };
        state.searchConfigMap = { ...moduleMap };
        state.conditionSort = [...conditionSort];
    },
    [TYPES.SEARCH_RESET_MUTATION](state, payload = []) {
        Object.keys(state.conditions).forEach(name => {
            if (!payload.includes(name)) {
                Vue.delete(state.conditions, name);
            }
        });
    },
    [TYPES.RESET_KEY_WORDS](state) {
        state.keywords = [];
    },
    [TYPES.CENTER_SET_UI_CONFIG](state, payload) {
        state.uiConfig = { ...payload };
    },
    [TYPES.CENTER_COMPUTED_PRESET_FILTER](state, payload) {
        state.computedPresetFilter = payload;
    },
    [TYPES.CENTER_UPDATE_CONDITION](state, payload) {
        if (payload.name === 'propertytype') {
            setRecentlyPropertyType(payload.data.value);
        }
        state.conditions = {
            ...state.conditions,
            ...{ [payload.name]: payload.data }
        };
    },
    [TYPES.CENTER_RESET_CONDITION](state) {
        state.conditions = {};
    },
    [TYPES.CENTER_UPDATE_UI_CONFIG_ITEM](state, payload) {
        const { name, data } = payload;
        const originConfig = state.uiConfig;
        let config = originConfig[name] || {};
        config = { ...config, ...{ [name]: data } };
        state.uiConfig = { ...originConfig, ...config };
        postUiConfig(state.uiConfig);
    },

    [TYPES.CENTER_DEL_CONDITION](state, payload) {
        // const index = state.conditionsArr.indexOf(payload);
        // state.conditionsArr.splice(index, 1);
        Vue.delete(state.conditions, payload);
    },
    [TYPES.CENTER_DEL_INPUT_BOX](state, payload) {
        const { name, delTag } = payload;
        const condition = state.conditions[name];
        const value = condition.value;
        if (/^,/.test(value) || /,$/.test(value)) {
            // const index = state.conditionsArr.indexOf(name);
            // state.conditionsArr.splice(index, 1);
            Vue.delete(state.conditions, name);
        } else {
            const temp = value.split(',');
            temp[delTag] = '';
            state.conditions[name].value = temp.join(',');
        }
    },
    [TYPES.CENTER_DEL_SUGGESTION](state, payload) {
        const { name, delTag } = payload;
        const condition = state.conditions[name];
        if (condition.value.length === 1) {
            Vue.delete(state.conditions, name);
        } else {
            state.conditions[name].value.splice(delTag, 1);
        }
    },
    [TYPES.CENTER_DEL_KEYWORD](state, payload) {
        const { name, delTag } = payload;
        const condition = state.conditions[name];
        if (condition.value.length === 1) {
            Vue.delete(state.conditions, name);
        } else {
            const index = condition.value.indexOf(delTag);
            state.conditions[name].value.splice(index, 1);
        }
    },
    [TYPES.CENTER_DEL_SELECT](state, payload) {
        // const index = state.conditionsArr.indexOf(payload);
        // state.conditionsArr.splice(index, 1);
        Vue.delete(state.conditions, payload);
    },
    [TYPES.CENTER_SET_SWITCH](state, payload) {
        const { checked, kee } = payload || {};
        if (checked) {
            Vue.set(state.conditions, kee, {
                value: true,
                type: 'checkBox'
            });
            // state.conditionsArr.push(kee);
        } else {
            // const index = state.conditionsArr.indexOf(kee);
            // state.conditionsArr.splice(index, 1);
            Vue.delete(state.conditions, kee);
        }
    },
    [TYPES.CENTER_URL_PRESET_PARAMS](state, payload) {
        state.urlPresetParams = payload;
    },
    [TYPES.CENTER_CONDITION_ON_URL](state, payload) {
        state.conditionOnUrl = { ...payload };
    }
};
export default ({ searchCenter }) => {
    return {
        ...(searchCenter ? centerMutations : mutations)
    };
};
